import { queryOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { listAlerts, markAlertAsRead, type UserAlert } from "@/lib/api/alerts";

export const alertKeys = {
  all: ["alerts"] as const,
  lists: () => [...alertKeys.all, "list"] as const,
  list: () => [...alertKeys.lists()] as const,
};

export const alertsQueryOptions = queryOptions({
  queryKey: alertKeys.list(),
  queryFn: () => listAlerts(),
});

export function useMarkAlertAsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (alertId: string) => markAlertAsRead(alertId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: alertKeys.lists() });
    },
  });
}

export type { UserAlert };
